import { render, staticRenderFns } from "./TabsHistory.vue?vue&type=template&id=60f91bba&scoped=true&"
import script from "./TabsHistory.vue?vue&type=script&lang=js&"
export * from "./TabsHistory.vue?vue&type=script&lang=js&"
import style0 from "./TabsHistory.vue?vue&type=style&index=0&id=60f91bba&lang=scss&scoped=true&"
import style1 from "./TabsHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f91bba",
  null
  
)

export default component.exports